export enum CategoryMode{
    ALL = 'ALL',
    GRID = 'GRID',
    LIST = 'LIST'
}

